import { i18n } from '@lingui/core'
import { useEffect, useState } from 'react'

const DEFAULT_LOCALE = 'en'

// Keeps library components reactive to host-app locale switches via Lingui's i18n event.
export const useLuneI18nLocale = (): string => {
    const [locale, setLocale] = useState(() => i18n.locale || DEFAULT_LOCALE)

    useEffect(() => {
        const handleChange = () => {
            setLocale(i18n.locale || DEFAULT_LOCALE)
        }

        const unsubscribe = i18n.on('change', handleChange)
        return unsubscribe
    }, [])

    return locale
}
